import React from "react";
import Sucesscheck from "icons/Sucesscheck";

interface GiftPaymentsuccessfulProps {
  transactionId: string;
  transactionAmount: string;
  setPaymentCompleted: Function;
  setGiftBitPopup: Function;
}
export const GiftPaymentsuccessful: React.FC<GiftPaymentsuccessfulProps> = ({
  transactionId,
  transactionAmount,
  setPaymentCompleted,
  setGiftBitPopup,
}) => {
  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-black/70 backdrop-blur-md px-5 z-999 flex items-center justify-center">
        <div className="bg-white w-[95%] max-w-458px   px-8 py-8  rounded-xl z-50 text-center space-y-3 relative">
          <div className="bg-green/20 border-green border w-20 h-20 rounded-full flex items-center justify-center mx-auto">
            <Sucesscheck className="fill-green" />
          </div>
          <div className="max-w-80 space-y-3 mx-auto">
            <h5 className="text-2xl font-semibold text-black">
              Payment Successful
            </h5>
          </div>
          <div className="w-full">
            <ul>
              <li className="p-2 flex  sm:flex-row flex-col  sm:flex-nowrap flex-wrap items-center justify-between rounded-sm">
                <p className="text-sm text-darkgray font-normal">
                  Payment Type:
                </p>
                <p className="text-sm text-darkgray font-normal">Stripe </p>
              </li>
              <li className="p-2 flex   sm:flex-row flex-col  sm:flex-nowrap flex-wrap  items-center justify-between rounded-sm">
                <p className="text-sm text-darkgray font-normal">
                  Transaction ID:
                </p>
                <p className="text-sm text-darkgray font-normal">
                  {transactionId}
                </p>
              </li>
              <li className="p-2 flex   sm:flex-row flex-col  sm:flex-nowrap flex-wrap  items-center justify-between bg-lightgray rounded-sm">
                <p className="text-sm text-black font-normal">Amount Paid: </p>
                <p className="text-sm text-black font-normal">
                  NZD ${transactionAmount}
                </p>
              </li>
            </ul>
          </div>
          <div
            className="flex items-center justify-center gap-4 !mt-5"
            onClick={(e) => {
              setPaymentCompleted(false);
              setGiftBitPopup(false)
            }}
          >
            <button className="text-base font-semibold w-full text-black rounded-full  transition-all duration-300 bg-skyblue transition-all ease-in-out duration-300 border hover:bg-white border-skyblue px-8 py-2.5">
              Done
            </button>
          </div>
          <p className="mt-0 pt-0 font-normal text-xs text-darkgray">Thank you for your support. Enjoy ;-)</p>
        </div>
      </div>
    </>
  );
};
